<script>
import { HorizontalBar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'
export default {
    extends: HorizontalBar,
    props:['dataNTR'],
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{
                    label: 'Active',
                    data: [],
                    backgroundColor: []
                }]
            },
            options: {
                tooltips:{
                  enabled: true
                },
                legend: {
                    display: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            fontSize: 14,
                            fontStyle: "bold",
                            callback: function(value) {
                                return value + '%';
                            }
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            display: false
                        },
                        scaleLabel: {
                            display: false,
                        }
                    }]
                }
            }
        }
    },
    methods:{
        getChart(){
            let dataNTR = this.dataNTR;
            this.addPlugin(ChartDataLabels);
            this.chartData.labels = dataNTR["list"].map(label => label.split('-'));
            // Add tooltips to show full category name
            this.options.tooltips = {
                enabled: true,
                callbacks: {
                    title: function(tooltipItems) {
                        // Get the full original label before splitting
                        return dataNTR["list"][tooltipItems[0].index];
                    },
                    label: function(tooltipItem) {
                        return tooltipItem.xLabel.toFixed(2) + '%';
                    }
                }
            };
            // Add data labels to show values on bars
            this.options.plugins = {
                datalabels: {
                    anchor: function(value) {
                        return value.dataset.data[value.dataIndex].x < 0 ? 'end' : 'start';
                    },
                    align: function(value) {
                        return value.dataset.data[value.dataIndex].x < 0 ? 'end' : 'start';
                    },
                    formatter: function(value, context) {
                        const index = context.dataIndex;
                        // Get the original label text from dataNTR["list"]
                        return dataNTR["list"][index];
                    },
                    color: '#000',
                    font: {
                        weight: 'bold'
                    }
                }
            };
            this.chartData.datasets[0].data= dataNTR["data"];
            if (dataNTR.page === 'active-vs-passive') {
                this.chartData.datasets[0].backgroundColor = dataNTR["data"].map(value => value.x < 0 ? 'rgb(175, 239, 151)' : '#f08261');
            } else {
                this.chartData.datasets[0].backgroundColor = dataNTR["data"].map(value => value.x < 0 ? 'red' : '#AFEF97');
            }
            this.options.scales.xAxes[0].scaleLabel.labelString = dataNTR.name;
            this.options.scales.xAxes[0].ticks = {
                min: dataNTR.min,
                max: dataNTR.max,
                fontSize: 14,
                fontStyle: "bold",
                callback: function(value) {
                    return value.toFixed(2) + '%';
                }
            };
            this.renderChart(this.chartData, this.options);
            const dataLength = this.chartData.labels.length;
            const heightPerItem = 30; // adjust based on visual spacing
            const baseHeight = 100; // minimal height

            const canvas = document.getElementById("horizontalbar-chart");
            if (canvas) {
                canvas.style.height = `${baseHeight + dataLength * heightPerItem}px`;
                canvas.style.width = '100%';
            }
        }
    },
    watch:{
        dataNTR(){
            this.getChart()
        }
    }
}
</script>
